<main class="content-page">
  <section class="content-hero">
    <p class="content-kicker">{{ 'pages.about.kicker' | translate }}</p>
    <h1>{{ 'pages.about.title' | translate }}</h1>
    <p>{{ 'pages.about.lead' | translate }}</p>
  </section>

  <section class="split-section">
    <div>
      <h2>{{ 'pages.about.storyTitle' | translate }}</h2>
      <p>{{ 'pages.about.storyText1' | translate }}</p>
      <p>{{ 'pages.about.storyText2' | translate }}</p>
    </div>
    <img src="assets/images/store-front-peony.jpg" [alt]="'pages.about.imageAlt' | translate" />
  </section>

  <section class="info-cards" aria-label="D&D Twogether értékek">
    <article>
      <span>01</span>
      <h2>{{ 'pages.about.values.value1.title' | translate }}</h2>
      <p>{{ 'pages.about.values.value1.text' | translate }}</p>
    </article>
    <article>
      <span>02</span>
      <h2>{{ 'pages.about.values.value2.title' | translate }}</h2>
      <p>{{ 'pages.about.values.value2.text' | translate }}</p>
    </article>
    <article>
      <span>03</span>
      <h2>{{ 'pages.about.values.value3.title' | translate }}</h2>
      <p>{{ 'pages.about.values.value3.text' | translate }}</p>
    </article>
  </section>

  <section class="content-band">
    <div>
      <p class="content-kicker">{{ 'pages.about.ctaKicker' | translate }}</p>
      <h2>{{ 'pages.about.ctaTitle' | translate }}</h2>
      <p>{{ 'pages.about.ctaText' | translate }}</p>
    </div>
    <div class="content-actions">
      <a
        class="content-button primary"
        href="https://shop.twogetherflower.hu"
        target="_blank"
        rel="noopener"
      >
        {{ 'pages.shared.shop' | translate }}
      </a>
      <a
        class="content-button"
        href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
        target="_blank"
        rel="noopener"
      >
        {{ 'pages.shared.wolt' | translate }}
      </a>
      <a class="content-button" routerLink="/kapcsolat">{{ 'pages.shared.contact' | translate }}</a>
      <a class="content-button" routerLink="/szolgaltatasok">{{ 'pages.shared.services' | translate }}</a>
    </div>
  </section>
</main>
